import * as actions from "./actionsType";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  weightsPerTask: {},

  loadingFactor: false,
  saveLoadingFactor: false,

  loadingCriterion: false,
  saveLoadingCriterion: false,

  loadingTask: false,
  saveLoadingTask: false,

  factorsCriteriaLength: 0,
  factorsCriteria: [],
  factorCriterion: {},
  factorCriterionError: "",

  formError: "",
  factorsLength: 0,
  factors: [],
  factor: {},
  factorError: "",
  criteria: [],
  criterion: {},
  criteriaLength: 0,
  criteriaError: "",
  tasks: [],
  task: {},
  tasksLength: 0,
  taskError: ""
};

export default function FactorCriterionReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_FACTORCRITERION:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_FACTORCRITERION:
      return { ...state, saveLoading: action.payload };
    case actions.GET_FACTORCRITERION:
      return {
        ...state,
        factorsCriteria: action.payload.factorsCriteria,
        factorsCriteriaLength: action.payload.factorsCriteriaLength,
        weightsPerTask: action.payload.weightsPerTask
      };
    case actions.GET_FACTORCRITERION_BY_ID:
      return { ...state, factorCriterion: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FACTORCRITERION_FAIL:
      return { ...state, factorCriterionError: action.payload };

    //factores
    case actions.LOADING_FACTOR:
      return { ...state, loadingFactor: action.payload };

    case actions.SAVE_LOADING_FACTOR:
      return { ...state, saveLoadingFactor: action.payload };

    case actions.GET_FACTOR:
      return {
        ...state,
        factors: action.payload.factors,
        factorsLength: action.payload.factorsLength,
      };
    case actions.FACTOR_FAIL:
      return { ...state, factorError: action.payload };

      //criterios
    case actions.LOADING_CRITERION:
      return { ...state, loadingCriterion: action.payload };
    case actions.SAVE_LOADING_CRITERION:
      return { ...state, saveLoadingCriterion: action.payload };
    case actions.GET_CRITERION:
      return {
        ...state,
        criteria: action.payload.criteria,
        criteriaLength: action.payload.criteriaLength,
      };
    case actions.CRITERION_FAIL:
      return { ...state, criteriaError: action.payload };



    //funciones
    case actions.LOADING_TASK:
      return { ...state, loadingTask: action.payload };
    case actions.SAVE_LOADING_TASK:
      return { ...state, saveLoadingTask: action.payload };
    case actions.GET_TASK:
      return {
        ...state,
        tasks: action.payload.tasks,
        tasksLength: action.payload.tasksLength,
      };
    case actions.TASK_FAIL:
      return { ...state, taskError: action.payload };

    default:
      return state;
  }
}
